// Estonian shortened time-ago strings
const shortTimeFormatterEstonian = {
  prefixAgo: null,
  prefixFromNow: null,
  suffixAgo: '',
  suffixFromNow: '',
  seconds: '1 sek',
  minute: '1 min',
  minutes: '%d min',
  hour: '1h',
  hours: '%dh',
  day: '1 päev',
  days: '%d päeva',
  month: '1 kuu',
  months: '%d kuud',
  year: '1 aasta',
  years: '%d aastat',
  wordSeparator: ' ',
};

export default shortTimeFormatterEstonian;
